import { Logo } from "@/components/shared/Logo";
import { RegisterForm } from "@/components/auth/RegisterForm";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

export function Register() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container flex items-center justify-center py-8">
        <div className="w-full max-w-md space-y-8">
          <Logo />
          <RegisterForm />
        </div>
      </main>
      <Footer />
    </div>
  );
}
